module.exports = __webpack_public_path__ + "img/time.ed3d545e.svg";